import React, { useEffect, useState } from "react";
import API from "../Service/Baseservice";
import { useNavigate } from "react-router-dom";
import Edit from "../../Assets/img/Edit.svg";
import Delete from "../../Assets/img/Delete.svg";
import Comment from "../../Assets/img/comment.png"
import dateIcon from "../../Assets/img/date.png";
import Search from "../../Assets/img/search.png";
import Search1 from "../../Assets/img/search-normal.png";
import Calendar from "../../Assets/img/calendar.png";
import "../News/News.css";
import "./Blog.css";
import Loading from "../../Loading/loading";
import Bloghuman from "../../Assets/img/bloghuman.png";
import { useLocation } from "react-router-dom";

const Blog = () => {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(6);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    const [showPopup, setShowPopup] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [tagMap, setTagMap] = useState({});
    const [commentCounts, setCommentCounts] = useState({});

    const [showCommentsPopup, setShowCommentsPopup] = useState(false);
    const [comments, setComments] = useState([]);
    const [selectedBlogId, setSelectedBlogId] = useState(null);
    const [languageId, setLanguageId] = useState(1);
    const [immigrationType, setImmigrationType] = useState([]);
    const [immigration, setImmigration] = useState("");

    useEffect(() => {
        API.post("blogtag_list/condition", { search: "", status: "active" })
            .then((res) => {
                const tagArray = res?.data?.data?.data || [];
                const map = {};
                tagArray.forEach((tag) => {
                    map[tag.blog_tag_id] = tag.blogtag;
                });
                setTagMap(map);
            })
            .catch((err) => console.error("Failed to fetch tags:", err));
    }, []);

    useEffect(() => {
        fetchBlogs();
    }, [languageId, page, immigration]); // Added immigration as dependency

    const fetchBlogs = () => {
        setLoading(true);
        const payload = {
            search,
            status,
            from_date: fromDate,
            to_date: toDate,
            rowsPerPage,
            page,
            language_id: languageId,
            blogseo_id: immigration,
        };
        
        console.log("Fetch blogs payload:", payload);

        API.post("blogs_list/condition", payload)
            .then((res) => {
                const blogData = (res?.data?.data?.data || []).filter(
                    (item) => item.active !== 4
                );
                const totalCount = res?.data?.data?.data1?.[0]?.totalcount || blogData.length;
                setTotalItems(totalCount);const calculatedTotalPages = Math.ceil(totalCount / rowsPerPage);
                setTotalPages(calculatedTotalPages);
                
                setBlogs(blogData);
            })
            .catch((err) => {
                console.error("Failed to fetch blogs:", err);
                setBlogs([]);
                setTotalPages(1);
                setTotalItems(0);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (blogs.length === 0) return;

        const blogIds = blogs.map(b => b.blog_id);

        API.post("blogcomments_list/condition", {
            blog_id: blogIds,
            language_id: languageId,
            status: ""
        })
            .then(res => {
                const counts = {};
                (res?.data?.data?.count || []).forEach(item => {
                    counts[item.blog_id] = item.total;
                });
                setCommentCounts(counts);
            })
            .catch(err => console.error("Failed to fetch comments:", err));
    }, [blogs, languageId]);

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";
        API.post("blog_status/update", { blog_id: id, status: newStatus })
            .then(() => fetchBlogs())
            .catch((err) => console.error("Failed to update status:", err));
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowPopup(true);
    };

    const confirmDelete = () => {
        if (!deleteId) return;
        API.post("blog_delete/update", { blog_id: deleteId, active: 4 })
            .then(() => {
                setShowPopup(false);
                setDeleteId(null);
                if (blogs.length === 1 && page > 1) {
                    setPage(page - 1);
                } else {
                    fetchBlogs();
                }
            })
            .catch((err) => console.error("Failed to delete blog:", err));
    };

    const handleNext = () => {
        if (page < totalPages) setPage(page + 1);
    };

    const handlePrev = () => {
        if (page > 1) setPage(page - 1);
    };

    const fetchComments = (blogId) => {
        setSelectedBlogId(blogId);
        setShowCommentsPopup(true);
        setComments([]);
        setLoading(true);

        API.post("blogcomments_list/condition", {
            blog_id: blogId,
            language_id: languageId,
            status: ""
        })
            .then((res) => {
                const commentList = res?.data?.data?.data || [];
                setComments(commentList);
            })
            .catch((err) => {
                console.error("Failed to fetch comments:", err);
                setComments([]);
            })
            .finally(() => setLoading(false));
    };

    const handleToggleCommentStatus = (comment) => {
        const newStatus = comment.status === "active" ? "inactive" : "active";
        API.post("blogcomments_status/update", {
            comment_id: comment.comment_id,
            status: newStatus,
        })
            .then(() => {
                setTimeout(() => fetchComments(comment.blog_id), 300);
            })
            .catch((err) => console.error("Failed to update comment status:", err));
    };

    const formatTimeAgo = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        const now = new Date();
        const diffMs = now - date;

        const seconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);

        if (seconds < 60) return "just now";
        if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
        if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
        if (days < 30) return `${days} day${days > 1 ? "s" : ""} ago`;
        if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
        return `${years} year${years > 1 ? "s" : ""} ago`;
    };

    const handleSearch = () => {
        setPage(1);
        localStorage.removeItem("blogPage");
        fetchBlogs();
    };
    
    useEffect(() => {
        if (location.state?.page) {
            setPage(location.state.page);
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);

    const fetchimmigration = (langId = languageId) => {
        API.post("blogseo_list/condition", { language_id: langId })
            .then((res) => {
                const immigrationData = (res?.data?.data?.data || [])
                    .slice()
                    .sort((a, b) => Number(a.order_by) - Number(b.order_by));
                setImmigrationType(immigrationData);
            })
            .catch((err) => console.error("Failed to fetch immigration types:", err));
    };
    
    useEffect(() => {
        fetchimmigration(languageId);
    }, [languageId]);

    return (
        <div className="blog-container">
            <div className="category-header1">
                <h2 className="newss-title">Blogs</h2>
                <button onClick={() => navigate("/blogadd")} className="add-btn">
                    <strong>+</strong> Add Blog
                </button>
            </div>

            {/* Filters */}
            <div className="filter-rows">
                <div className="filter-block">
                    <label>Search By</label>
                    <div className="input-container">
                        <input
                            placeholder="Search by anything"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="input-field"
                        />
                        <img
                            src={Search1}
                            alt="Search"
                            className="search-icon"
                            onClick={fetchBlogs}
                        />
                    </div>
                </div>

                <div className="filter-block">
                    <label>Status</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => setStatus(e.target.value)}
                            value={status}
                            className="input-field"
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>
                
                <div className="filter-block">
                    <label>Blog Service Name</label>
                    <div className="input-container-consultation">
                        <select
                            value={immigration}
                            onChange={(e) => setImmigration(e.target.value)}
                            className="input-field"
                        >
                            <option value="">Select Service</option>
                            {immigrationType.map((cat) => (
                                <option
                                    key={cat.blogseo_id}
                                    value={cat.blogseo_id}
                                >
                                    {cat.heading}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>From</label>
                    <div className="date-container">
                        <input
                            type="date"
                            value={fromDate}
                            max={toDate || undefined}
                            onChange={(e) => {
                                const val = e.target.value;
                                setFromDate(val);
                                if (toDate && val > toDate) {
                                    setToDate("");
                                }
                            }}
                            className="input-field"
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                        />
                        <img
                            src={Calendar}
                            alt="Calendar"
                            className="date-icon"
                            onClick={() => document.querySelector('input[type="date"]').showPicker?.()}
                        />
                    </div>
                </div>

                <div className="filter-block">
                    <label>To</label>
                    <div className="date-container">
                        <input 
                            value={toDate} 
                            min={fromDate || undefined} 
                            type="date" 
                            onChange={(e) => setToDate(e.target.value)} 
                            className="input-field"
                            onClick={(e) => e.target.showPicker && e.target.showPicker()} 
                        />
                        <img
                            src={Calendar}
                            alt="Calendar"
                            className="date-icon"
                            onClick={() =>
                                document.querySelectorAll('input[type="date"]')[1]?.showPicker?.()
                            }
                        />
                    </div>
                </div>
                
                {/* Language */}
                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                                setPage(1);
                            }}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>
                
                <div className="filter-btn-wrapper" onClick={handleSearch}>
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="newss-grid">
                        {blogs.length > 0 ? (
                            blogs.map((item) => (
                                <div key={item.blog_id} className="newss-card">
                                    <div className="cards-footer">
                                        <div className="status-container">
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.status === "active"}
                                                    onChange={() => handleToggleStatus(item.blog_id, item.status)}
                                                />
                                                <span className="slider round">
                                                    <span className="switch-label">
                                                        {item.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>

                                        <div className="action-buttons">
                                            <div
                                                className="comment-icon-wrapper"
                                                onClick={() => fetchComments(item.blog_id)}
                                            >
                                                <img
                                                    src={Comment}
                                                    alt="Comments"
                                                />
                                                <span className="comment-count">
                                                    {commentCounts[item.blog_id] || 0}
                                                </span>
                                            </div>

                                            <img
                                                src={Edit}
                                                alt="Edit"
                                                className="edit-icon-btn"
                                                onClick={() =>
                                                    navigate(`/blogedit/${item.blog_id}`, { state: { blog: item, page } })
                                                }
                                            />

                                            <img
                                                src={Delete}
                                                alt="Delete"
                                                className="edit-icon-btn"
                                                onClick={() => handleDeleteClick(item.blog_id)}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        {item.blog_image && (
                                            <img src={item.blog_image} alt={item.heading} className="blog-image mt-4" />
                                        )}
                                    </div>

                                    <div className="author-date-row">
                                        <img src={Bloghuman} alt="profile" />
                                        <span className="author-name">{item.author_name}</span>
                                        <div className="date-badge">
                                            <img src={dateIcon} alt="Date" />
                                            <span className="date-text">{item.blog_date?.split(" ")[0]}</span>
                                        </div>
                                        <div className="tag-display">
                                            {(() => {
                                                let tagNames = [];
                                                try {
                                                    const ids = JSON.parse(item.blog_tag_id || "[]");
                                                    tagNames = ids.map(id => tagMap[id]).filter(Boolean);
                                                } catch (e) {
                                                    console.warn("Invalid tag JSON:", item.blog_tag_id);
                                                }

                                                if (tagNames.length === 0) return null;
                                                if (tagNames.length === 1) return <span className="blog-tag">{tagNames[0]}</span>;
                                                return <span className="blog-tag">{tagNames[0]} ...</span>;
                                            })()}
                                        </div>
                                    </div>

                                    <h3
                                        className="newss-heading clickable-title"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/blogview/${item.blog_id}`, { state: { blog: item } });
                                        }}
                                    >
                                        {item.heading}
                                    </h3>

                                    <div
                                        className="blog-description clickable-description mb-4"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/blogview/${item.blog_id}`, { state: { blog: item, page } });
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: item.description.replace(/<[^>]+>/g, ''),
                                        }}
                                    />
                                </div>
                            ))
                        ) : (
                            <p className="no-faq-text">No blogs found.</p>
                        )}
                    </div>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                        <div className="pagination-container">
                            <button
                                className="pagination-btn"
                                onClick={handlePrev}
                                disabled={page === 1}
                            >
                                Prev
                            </button>
                            {(() => {
                                const pageNumbers = [];
                                const maxVisible = 5;

                                if (totalPages <= maxVisible) {
                                    for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
                                } else {
                                    if (page <= 3) {
                                        pageNumbers.push(1, 2, 3, "...", totalPages);
                                    } else if (page >= totalPages - 2) {
                                        pageNumbers.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
                                    } else {
                                        pageNumbers.push(1, "...", page - 1, page, page + 1, "...", totalPages);
                                    }
                                }

                                return pageNumbers.map((num, index) =>
                                    num === "..." ? (
                                        <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                                            ...
                                        </span>
                                    ) : (
                                        <button
                                            key={num}
                                            className={`pagination-btn ${page === num ? "active" : ""}`}
                                            onClick={() => setPage(num)}
                                        >
                                            {num}
                                        </button>
                                    )
                                );
                            })()}
                            <button
                                className="pagination-btn"
                                onClick={handleNext}
                                disabled={page === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    )}
                    
                    {/* Show total items info */}
                    {totalItems > 0 && (
                        <div className="pagination-info">
                            Showing {((page - 1) * rowsPerPage) + 1} to {Math.min(page * rowsPerPage, totalItems)} of {totalItems} items
                        </div>
                    )}
                </>
            )}

            {/* Custom Delete Popup */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3>Confirm Delete</h3>
                        <p>Are you sure you want to delete this blog?</p>
                        <div className="popup-buttons">
                            <button className="cancel-btn" onClick={() => setShowPopup(false)}>
                                Cancel
                            </button>
                            <button className="btn delete-btn" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Comments Popup */}
            {showCommentsPopup && (
                <div className="comment-popup-overlay">
                    <div className={`comment-popup-box ${loading ? "popup-loading" : ""}`}>
                        <h3>Blog Comments</h3>

                        {loading ? (
                            <div className="loader-wrapper-comments">
                                <Loading />
                            </div>
                        ) : comments.length > 0 ? (
                            <div className="comment-list">
                                {comments.map((cmt) => (
                                    <div key={cmt.comment_id} className="comment-item">
                                        <div className="comment-header">
                                            <div className="comment-info">
                                                <strong>Name:</strong> {cmt.user_name}
                                                <span>({cmt.email})</span>
                                                <span style={{ marginLeft: "6px", color: "#888", fontSize: "13px" }}>
                                                    {formatTimeAgo(cmt.createdAt)}
                                                </span>
                                            </div>
                                            <label className="comment-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={cmt.status === "active"}
                                                    onChange={() => handleToggleCommentStatus(cmt)}
                                                />
                                                <span className="comment-slider round">
                                                    <span className="comment-switch-label">
                                                        {cmt.status === "active" ? "ON" : "OFF"}
                                                    </span>
                                                </span>
                                            </label>
                                        </div>
                                        <div className="comment-p">
                                            <strong>Comment:</strong>
                                            <p className="comment-text">{cmt.comments}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p>No comments found.</p>
                        )}

                        <div className="comment-popup-buttons">
                            <button
                                className="cancel-btn"
                                onClick={() => setShowCommentsPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Blog;